module.exports = __webpack_public_path__ + "images/promos/moving-supplies.jpg";